import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import scopeImage from '../../../Assets/ResearchLabs/SSTRL/SSTRL-Scope.jpg';

const { Paragraph, Title } = Typography;

const SstrlScope = () => (
  <section className="scope-section">
    <div className="scope-section-inner">
      <Row gutter={[72, 40]} align="middle" justify="space-between">
        <Col xs={24} md={14}>
          <Title level={2} className="scope-title">Scope</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph className="scope-description">
            SSTRL builds national capacity in small-satellite technology while giving Pakistani students opportunities to conduct space experiments through SUPARCO and international collaborations.
          </Paragraph>
        </Col>
        <Col xs={24} md={9}>
          <div className="scope-image-wrap">
            <img src={scopeImage} alt="Small satellite technology" className="scope-image" />
          </div>
        </Col>
      </Row>
    </div>
  </section>
);

export default SstrlScope;
